import {useQuery} from 'react-query';
import {FeatureDetailVO, FeaturePointerVO, ServicesApi} from '../api';
import {GroupFeaturePointer, LayerId} from '@mc/react-mapio';
import {useMapioContext} from '../mapioContext';

export const CACHE_KEY_FEATURE_DETAIL = 'CACHE_KEY_FEATURE_DETAIL';

export const useFeatureDetail = (groupFeaturePointers: GroupFeaturePointer[], externalLayerIds: LayerId[]) => {
    const {
        value: {topicId, context},
    } = useMapioContext();

    const selectedFeaturePointer: FeaturePointerVO[] = groupFeaturePointers
        .filter((item: GroupFeaturePointer) => !externalLayerIds.includes(item.layerId)) // features z externích vrstev ignorujeme
        .map((item: GroupFeaturePointer): FeaturePointerVO => {
            return {
                // Primární ID se určuje vždy v pořadí GROUP_ID, NESTED_ID, FEATURE_ID
                featureId: item.groupId ?? item.featureId?.toString(),
                layerId: Number(item.layerId),
            };
        });

    return useQuery<FeatureDetailVO[]>(
        [CACHE_KEY_FEATURE_DETAIL, JSON.stringify(groupFeaturePointers)],
        async () => (await ServicesApi.getFeatureDetail(topicId, context, 'long', 'desktop', null, null, selectedFeaturePointer)).data,
        {
            enabled: Boolean(groupFeaturePointers && groupFeaturePointers.length > 0),
            refetchOnWindowFocus: true,
            refetchOnReconnect: false,
            refetchOnMount: false,
        },
    );
};
